import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=a368b170&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputTextArea.vue?vue&type=style&index=0&id=a368b170&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a368b170",
  null
  
)

export default component.exports